import { useEffect } from 'react';
import { useAppDispatch } from 'store/hooks';
import settingServiceActions from '../actions';
import settingServiceSelectors from '../selectors';

const useGetFeeCreditCard = (lazy?: boolean) => {
  const dispatch = useAppDispatch();
  const data = settingServiceSelectors.getFeeCreditCard();

  const mutate = () => {
    dispatch(settingServiceActions.getFeeCreditCard.fetch());
  };

  useEffect(() => {
    if (!lazy) {
      mutate();
    }
  }, []);

  return [data, mutate] as const;
};

export default useGetFeeCreditCard;
